import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const Firewall = () => {
  const location = useLocation();
  const fromPath = location.state?.from?.pathname || '/';

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>⛔</div>
        <h1 style={styles.title}>Access Restricted</h1>
        <p style={styles.text}>Your role is not able to access these pages.</p>
        <p style={styles.subtext}>You must be in a group named "Super - Admin".</p>
        <div style={styles.actions}>
          <Link to={fromPath} style={styles.linkBtn}>Go Back</Link>
          <Link to="/" style={styles.primaryBtn}>Go Home</Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  },
  card: {
    background: '#ffffff',
    borderRadius: '14px',
    padding: '28px',
    width: '100%',
    maxWidth: '560px',
    textAlign: 'center',
    boxShadow: '0 12px 40px rgba(0,0,0,0.12)'
  },
  icon: { fontSize: '42px', marginBottom: '6px' },
  title: { margin: '8px 0', color: '#111827' },
  text: { margin: '0 0 8px 0', color: '#374151' },
  subtext: { margin: 0, color: '#6b7280' },
  actions: { display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '16px', flexWrap: 'wrap' },
  linkBtn: {
    padding: '10px 14px',
    borderRadius: '8px',
    border: '2px solid #e5e7eb',
    color: '#111827',
    textDecoration: 'none',
    background: '#fff'
  },
  primaryBtn: {
    padding: '10px 14px',
    borderRadius: '8px',
    border: 'none',
    color: '#fff',
    textDecoration: 'none',
    background: '#4f46e5'
  }
};

export default Firewall;


